<template>
  <v-row no-gutters>
    <v-col class="text-left pt-10">
      <template v-if="activeItem">
        <data-input
          v-for="(item, index) in computedItems"
          :key="index"
          :data-type="dataInputText"
          :value="item.value"
          :label="item.label"
          readonly
        ></data-input>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import DataInput from '@/components/DataInput';
export default {
  name: 'ZDMActionPreview',
  components: { DataInput },
  props: {
    activeItem: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    dataInputText: { name: 'text' },
  }),
  methods: {
    getLabel(k) {
      return this.$i18n.t(`dialog.body.${k}`);
    },
  },
  computed: {
    computedItems() {
      return Object.keys(this.activeItem)
        .filter(key => key !== 'id' && key !== 'name')
        .map(k => {
          return {
            value: this.activeItem[k],
            label: this.getLabel(k),
          };
        });
    },
  },
};
</script>

<style scoped lang="scss">
.actionContainer {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}
.saveSection {
  height: 50px;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  align-self: flex-end;
}
</style>
